module.exports = __webpack_public_path__ + "img/xzwm4.28ac19c2.jpg";